// extracted by mini-css-extract-plugin
export var fadeInOut = "_3p-3";
export var icon = "_3p-4";
export var savedIndicator = "_3p-2";
export var savingIndicator = "_3p-0";
export var spin = "_3p-1";